import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {RestKundendatenadminService} from '@app/core/api/kundendatenadmin.service';
import {ActiveKundendatenadminQuery} from '@app/core/state/active-kundendatenadmin/active-kundendatenadmin.query';
import {ActiveKundendatenadminStore} from '@app/core/state/active-kundendatenadmin/active-kundendatenadmin.store';
import {PayloadUtil} from '@app/core/util/payload.util';
import { KundendatenPersonBeziehung, PayloadKundendatenPersonBeziehung } from '@pezi/entities';
import {Subscription, take} from 'rxjs';
import {setProps} from "@ngneat/elf";
import { PersistentTabService } from '../persistent-tab/persistent-tab.service';
import { PersistentTabUtil } from '../persistent-tab/persistent-tab.util';

@Injectable({providedIn: 'root'})
export class ActiveKundendatenadminService {

  private subscription: Subscription;

  constructor(private activeKundendatenadminStore: ActiveKundendatenadminStore,
              private activeKundendatenadminQuery: ActiveKundendatenadminQuery,
              private kundendatenadminService: RestKundendatenadminService,
              private snackBar: MatSnackBar, private persistentTabService: PersistentTabService) {
  }

  initKundendatenadminErsetzt(id: string, reload?: boolean) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.activeKundendatenadminStore.data.update(setProps({
        loading: false
      }));
    }
    const currentState = this.activeKundendatenadminStore.data.getValue();
    if (!id) {
      this.clearStore();
    } else if (!currentState.kundendatenPersonBeziehungErsetzt || currentState.kundendatenPersonBeziehungErsetzt.person.id !== +id || reload) {
      this.activeKundendatenadminStore.data.reset();
      this.activeKundendatenadminStore.data.update(setProps({
        loading: true
      }));
      this.getErsetztKunde(id, reload);

    }
  }

  initKundendatenadminVerbund(id: string, reload?: boolean) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.activeKundendatenadminStore.data.update(setProps({
        loading: false
      }));
    }
    const currentState = this.activeKundendatenadminStore.data.getValue();
    if (!id) {
      this.clearStore();
    } else if (!currentState.kundendatenPersonBeziehungVerbund || currentState.kundendatenPersonBeziehungVerbund.person.id !== +id || reload) {
      this.activeKundendatenadminStore.data.reset();
      this.activeKundendatenadminStore.data.update(setProps({
        loading: true
      }));
      this.getVerbund(id, reload);
    }
  }

  getErsetztKunde(id: string, reload?: boolean) {
    const cachedObs$ = this.persistentTabService.getCachedDataFromTabs<PayloadKundendatenPersonBeziehung>('/kundendatenadmin/ersetzen/' + id);
    this.subscription = (cachedObs$ && !reload ? cachedObs$ : this.kundendatenadminService.getKundendatenBeziehungen(id))
      .pipe(
        take(1)
      )
      .subscribe(result => {
        let kundendatenPersonBeziehungErsetzt: KundendatenPersonBeziehung;
        let errorLoadingKundendatenadmin = false;
        if (PayloadUtil.handlePayloadSnackbarErrorOnly(result, this.snackBar,
          'Fehler: Kundendaten-Beziehung konnte nicht geladen werden')) {
          kundendatenPersonBeziehungErsetzt = result.data;
        } else {
          errorLoadingKundendatenadmin = true;
        }
        this.activeKundendatenadminStore.data.update(setProps({
          loading:      false,
          errorLoading: errorLoadingKundendatenadmin,
          kundendatenPersonBeziehungErsetzt,
          kundendatenPersonBeziehung: kundendatenPersonBeziehungErsetzt
        }));
        this.persistentTabService.addTab({
          config: PersistentTabUtil.getKundendatenAdminTabConfig(kundendatenPersonBeziehungErsetzt, 'ersetzen'),
          data:   kundendatenPersonBeziehungErsetzt
        });
      });
  }

  getVerbund(id: string, reload?: boolean) {
    const cachedObs$ = this.persistentTabService.getCachedDataFromTabs<PayloadKundendatenPersonBeziehung>('/kundendatenadmin/verbund/' + id);
    this.subscription = (cachedObs$ && !reload ? cachedObs$ : this.kundendatenadminService.getKundendatenVerbund(id))
      .pipe(
        take(1)
      )
      .subscribe(result => {
        let kundendatenPersonBeziehungVerbund: KundendatenPersonBeziehung;
        let errorLoadingKundendatenadmin = false;
        if (PayloadUtil.handlePayloadSnackbarErrorOnly(result, this.snackBar,
          'Fehler: Kundendaten-Beziehung konnte nicht geladen werden')) {
          kundendatenPersonBeziehungVerbund = result.data;
        } else {
          errorLoadingKundendatenadmin = true;
        }
        this.activeKundendatenadminStore.data.update(setProps({
          loading:      false,
          errorLoading: errorLoadingKundendatenadmin,
          kundendatenPersonBeziehungVerbund,
          kundendatenPersonBeziehung: kundendatenPersonBeziehungVerbund
        }));
        this.persistentTabService.addTab({
          config: PersistentTabUtil.getKundendatenAdminTabConfig(kundendatenPersonBeziehungVerbund, 'verbund'),
          data:   kundendatenPersonBeziehungVerbund
        });
      })
  }

  clearStore() {
    this.activeKundendatenadminStore.data.reset();
  }
}
